import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import languageKey from './LanguageKey'

export const defaultLanguage = languageKey.th

i18n.use(Backend) // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init({
        lng: defaultLanguage,
        fallbackLng: defaultLanguage === languageKey.th ? languageKey.en : languageKey.th,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: {
            // for all available options read the backend's repository readme file
            loadPath: `${process.env.PUBLIC_URL}/language/{{lng}}.json`,
        },
    })
